module.exports = __webpack_public_path__ + "resources/img/main07_m.80100aa88222afc3930803336ec1fec4.png";